export default {
  workGuideApi: {
      //指引
      workGuide: {
        list: 'api/screen/workGuideApi/list',
        del: 'api/screen/workGuideApi/del',
        saveOrUpdate: 'api/screen/workGuideApi/saveOrUpdate'
      }

  }
}
